'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _Card=require('./Card');Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _interopRequireDefault(_Card).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}


/** WEBPACK FOOTER **
 ** ./~/@vitalsource/vstui/Card/index.js
 **/